export default {
  title: 'Dettagli fiscali',
  buttons: {
    save: 'Salva',
  },
  toasts: {
    success: 'Informazioni salvate con successo.',
  },
};
